import { uuid } from 'vue-uuid';
import { createNamespacedHelpers } from 'vuex';
import { showSwal } from '../../../util/swal';
import { showConfirmSwal, showSuccessSwal } from '@/util/swal';
import showToast from '@/util/toast';
import Constants from '@/constants/Constants.js';

import ModalPreview from '@/components/shared/ModalPreview/ModalPreview.vue';

const authMapper = createNamespacedHelpers('global/auth');
const imageMapper = createNamespacedHelpers('trainer/image');
const historyImageMapper = createNamespacedHelpers('history/image');

const cameraMapper = createNamespacedHelpers('trainer/camera');
const trainerMapper = createNamespacedHelpers('trainer');
const modelMapper = createNamespacedHelpers('trainer/model');
const globalMapper = createNamespacedHelpers('global');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');

// Limit the number of image in staging env is 1000
const BASE_LIMIT_SHOT = 20;
const STAGING_LIMIT_SHOT = 1000;
const LIMIT_INTERVAL_SHOT =
	process.env.VUE_APP_MODE === 'stag' || 'dev' ? STAGING_LIMIT_SHOT : BASE_LIMIT_SHOT;

let audio = new Audio(require('@/constants/sounds/shutter.mp3'));
export default {
	name: 'CameraPreview',

	components: {
		ModalPreview,
	},

	data() {
		return {
			camera: null,
			canvas: null,
			stream: null,
			timer: null,
			sliderPoint: 1,
			countdown: 0,
			// video el size
			height: document.documentElement.clientHeight,
			width: document.documentElement.clientWidth,
			ipadWidth: 640,
			ipadHeight: 480,
			iphoneWidth: 400,
			iphoneHeight: 300,
			type: 'TRAIN',

			HD_IMAGE_SIZE: Constants.HD_IMAGE_SIZE,
			onInterval: false,
			limitIntervalShot: LIMIT_INTERVAL_SHOT,

			//Captured images counter
			createdModelInformation: {},
			modalId: 'trainerModels',
			totalImages: BASE_LIMIT_SHOT,
			newModelName: '',
			modelDescription: '',
			summaryFile: null,

			showThumbnail: true,
			howThumbnail: true,
			dummyNumber: 100,
			cameraId: null,
			displayModel: undefined,
		};
	},

	computed: {
		...imageMapper.mapState([
			'images',
			'successUploadNumber',
			'pendingUploadNumber',
			'numberstep1',
			'numberstep2',
			'numberstep3',
		]),
		...imageMapper.mapGetters([
			'imagesReactiveLength',
			'reversedImages',
			'totalImageNumber',
		]),

		...authMapper.mapState(['username']),
		...cameraMapper.mapState(['auto', 'mode', 'focus']),
		...modelMapper.mapState(['models', 'model']),
		...historyImageMapper.mapState(['retrainingImages']),

		retrainingImagesLength() {
			return this.retrainingImages ? this.retrainingImages.length : 0;
		},

		existModel() {
			return this.models.some(
				(model) =>
					model.model_name === this.newModelName ||
					model.model_name === this.newModelName + '.pytorch'
			);
		},

		choosenDeleteModel() {
			return this.onChooseDeleteModel;
		},

		confirmDeleteModel() {
			return {
				title: this.$t('confirnDelete'),
				text: `Model ${this.choosenDeleteModel} ${this.$t('deleteModelText')}`,
				yesButton: this.$t('confirmYes'),
				noButton: this.$t('confirmNo'),
			};
		},

		confirmContent() {
			return {
				title: this.$t('success'),
				text: this.$t('confirmContent'),
				yesButton: this.$t('confirmYes'),
				noButton: this.$t('confirmNo'),
			};
		},

		PLACEHOLDER() {
			return {
				formFilePlaceholder: this.$t('formFilePlaceholder'),
				dropFormfilePlaceholder: this.$t('dropFormfilePlaceholder'),
				brownTextFormFilePlaceholder: this.$t('brownTextFormFilePlaceholder'),
			};
		},

		crosshair() {
			return this.focus;
		},

		amoutRequire() {
			return this.successUploadNumber >= BASE_LIMIT_SHOT;
		},

		amountRequireAndNewModelName() {
			if (!this.amoutRequire) {
				return true;
			}

			if (this.createdModelInformation?.newModelName === undefined) {
				return true;
			} else {
				this.SET_STEP3();
			}

			return false;
		},

		isModalVisible: {
			get() {
				return this.$store.state.trainer.isModalVisible;
			},
			set(value) {
				this.$store.dispatch('trainer/showFormModal', value);
			},
		},

		/**
		 * check if localstorage save new model at the last time
		 */
		modelLocalExisted() {
			return this.trainerLocalModel ? true : false;
		},

		/**
		 * get model name from localstorage if it existed, choose it, else choose default model
		 */
		startingModel() {
			let trainerSavedModel = localStorage.getItem(`${this.username}-${this.suffix}`);
			return !this.modelLocalExisted
				? this.model
				: this.models.some((model) => model.model_name === trainerSavedModel)
				? trainerSavedModel
				: this.model;
		},

		notFound() {
			return this.$t('notFound');
		},

		/**
		 * return model name to display or not found if model is empty
		 */
		displayedModel() {
			let model = this.models.find(({ model_name }) => model_name === this.model);
			
			if (model !== undefined) {
					this.displayModel = model.display.model_name
			}

			return this.displayModel || this.notFound
		},

		/**
		 * check if model is empty or not to disable button
		 */
		buttonDisabled() {
			return !this.model;
		},

		failNoti() {
			return this.$t('uploadTrainImageFail');
		},

		auto: {
			get() {
				return this.$store.state.trainer.camera.auto;
			},
			set() {
				this.$store.dispatch('trainer/camera/switchAuto');
			},
		},
		front: {
			get() {
				return this.$store.state.trainer.camera.front;
			},
			set() {
				this.$store.dispatch('trainer/camera/switchMode');
			},
		},
		focus: {
			get() {
				return this.$store.state.trainer.camera.focus;
			},
			set() {
				this.$store.dispatch('trainer/camera/toggleCrosshair');
			},
		},

		isDisableSelectModelBtn() {
			return process.env.VUE_APP_MODE === 'prod';
		},
	},
	async mounted() {
		const cameraId = await this.getCameraId();
		this.cameraId	= cameraId;
		this.loadVideoMetadata();
		this.openCamera(this.mode, this.cameraId);
		this.SET_STEP1();
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' && this.$route.fullPath === '/trainer') {
				if (!this.isModalVisible) {
					this.onCaptureBtnClick();
				}
			}
		});

		console.log({ env: process.env.VUE_APP_MODE });
	},
	async beforeDestroy() {
		this.closeCamera();
	},
	methods: {
		...imageMapper.mapActions([
			'uploadTrainerImages',
			'addImage',
			'startLearn',
			'deleteLocalImages',
			'resetTrainerImages',
		]),
		...globalMapper.mapActions(['setSpinner']),

		...imageMapper.mapMutations(['PUSH_IMAGE', 'SET_STEP1', 'SET_STEP2', 'SET_STEP3']),
		...trainerMapper.mapActions(['hideFormModal']),
		...modelMapper.mapActions(['retrieveModels', 'setModel', 'deleteModel']),
		...advancedSettingMapper.mapActions(['getCameraId']),

		isValid(invalid) {
			if (!this.model) {
				return true;
			}
			// if model exist and invalid => disable
			if (this.existModel && invalid) {
				return true;
			}

			// if model not exist and invalid => disable
			if (!this.existModel && !invalid) {
				return false;
			}

			return true;
		},

		loadVideoMetadata() {
			const videoElement = this.$refs.camera;
			videoElement.addEventListener('loadedmetadata', () => {
				this.showThumbnail = false;
			});
		},

		/**
		 * Icon start clicking event handler
		 */
		onStartInterval() {
			if (
				this.successUploadNumber >= LIMIT_INTERVAL_SHOT ||
				this.totalImageNumber >= LIMIT_INTERVAL_SHOT
			) {
				showToast({
					vueInstance: this,
					type: 'success',
					message: this.$t('fullCaptureImages'),
				});
				return;
			}
			this.SET_STEP2();
			this.onInterval = true;
			this.onCaptureBtnClick();
		},

		/**
		 * Capture btn click handler event
		 */
		async onCaptureBtnClick() {
			if (this.auto) {
				await this.execute();
			} else {
				if (this.totalImageNumber < LIMIT_INTERVAL_SHOT) {
					this.SET_STEP2();
					await this.capture();
				} else {
					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('fullCaptureImages'),
					});
				}
			}
		},

		hideModal() {
			this.hideFormModal();
		},

		onClickModelsListBtn() {
			this.$bvModal.show(this.modalId);
		},

		onCloseModal() {
			this.newModelName = '';
			this.$bvModal.hide('form-modal');
		},

		onClickSaveNewModel() {
			this.$refs.formValidator.validate().then((success) => {
				if (success) {
					this.createdModelInformation = {
						model: this.model,
						newModelName: this.newModelName,
						description: this.modelDescription,
						documentation: this.summaryFile,
					};
					this.$bvModal.hide('form-modal');

					if (this.totalImageNumber < LIMIT_INTERVAL_SHOT) {
						this.SET_STEP2();
					} else {
						if (!this.createdModelInformation.newModelName) {
							this.SET_STEP1();
						} else {
							this.SET_STEP3();
						}
					}
				}
			});
		},

		async onDeleteModel(model) {
			this.onChooseDeleteModel = model.model_name;
			const confirm = async () => {
				try {
					await this.deleteModel({
						username: model.username,
						model_name: model.model_name,
						model_id: model._id?.$oid,
					});

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('successDeleteModel'),
					});

					await this.retrieveModels({ username: this.username });
				} catch (error) {
					console.log({ error });
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('failDeleteModel'),
					});
				}
			};
			const dismiss = () => {};

			showConfirmSwal(this.confirmDeleteModel, confirm, dismiss);
		},

		async onSelectModel(modelName) {
			this.setSpinner(true);
			try {
				this.setModel({ model: modelName });
				// save model name to localstorage when choose new model
				localStorage.setItem(`${this.username}-${this.suffix}`, modelName);
				this.trainerLocalModel = localStorage.getItem(
					`${this.username}-${this.suffix}`
				);

				showToast({
					vueInstance: this,
					type: 'success',
					message: this.$t('successLoadModel'),
				});
			} catch (error) {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('failLoadModel'),
				});
			}
			this.setSpinner(false);
			this.$bvModal.hide(this.modalId);
		},

		/**
		 * Icon stop clicking event handler
		 */
		onStopInterval() {
			this.onInterval = false;
		},

		async onRequest() {
			try {
				this.setSpinner(true);
				if (!this.createdModelInformation) return;

				// handle style name for new model 
				const regex = /^\d{10}$|^\d{13}$/
				let templateModelName = `${this.createdModelInformation.model.replace(".pytorch", '')}`
				const tailName = templateModelName.split("_").pop()
				const firstName = templateModelName.substring(0, templateModelName.lastIndexOf('_'))

			if (regex.test(tailName)) {
				templateModelName = `${firstName}_${new Date().getTime()}`

			} else {
				templateModelName=`${templateModelName}_${new Date().getTime()}`
			}

				const formData = {
					username: this.username,
					template_name: this.createdModelInformation.model,
					model_name: templateModelName,
					display_model_name:this.createdModelInformation.newModelName,
					description: this.createdModelInformation.description,
					retrain_images: [],
					//   this.retrainingImages.map(item => {
					//   return item?.s3_key
					// })
				};

				let res = await this.startLearn(formData);
				// reset createdModelInformation to prevent duplicate request
				this.createdModelInformation = {};

				if (res.status !== 200) {
					this.setSpinner(false);
					showSwal({
						type: 'fail',
						title: this.$t('fail'),
						text: this.$t('failMessage'),
					});
					return;
				}

				const confirm = async () => {
					await this.deleteLocalImages({ username: this.username });
					this.resetTrainerImages();
					this.SET_STEP1();
				};
				const dismiss = () => {
					this.SET_STEP1();
				};

				showSuccessSwal(this.confirmContent, confirm, dismiss);

				await this.retrieveModels({ username: this.username });
				this.setSpinner(false);
			} catch (err) {
				this.setSpinner(false);

				if (err?.response?.data?.error === 'Send email error') {
					showConfirmSwal(
						{
							title: this.$t('success'),
							text: this.$t('sendMailError'),
							yesButton: this.$t('confirmYes'),
							noButton: this.$t('confirmNo'),
						},
						confirm,
						dismiss
					);
					return;
				}

				showSwal({
					type: 'fail',
					title: this.$t('fail'),
					text: this.$t('failMessage'),
				});
			}
		},

		async execute() {
			let lastShot = 0;

			/**
			 *  kiểm tra khi mà trong lúc countdown,
			 *  nút màu đỏ mà biến thành màu xanh thì ngưng countdown
			 */
			while (this.onInterval) {
				this.countdown = this.sliderPoint;

				for (let index = this.countdown; index > 0; index--) {
					if (!this.onInterval) {
						break;
					}
					this.countdown -= 1;
					await this.sleep(1000);
				}

				// Kiểm tra lại trước khi thực hiện capture
				if (this.onInterval) {
					await this.capture();
					/**
					 *  tăng biến lastShot lên 1 đơn vị,
					 *  đến khi nào bằng limitIntervalShot = 20 thì biến nút chụp thành màu xanh
					 */
					lastShot += 1;
					if (this.totalImageNumber >= LIMIT_INTERVAL_SHOT) {
						if (!this.createdModelInformation.newModelName) {
							this.SET_STEP1();
						}

						this.onInterval = false;
					}
				}

				if (lastShot === this.limitIntervalShot) {
					this.onInterval = false;
				}
			}
		},

		async capture() {
			audio.play();

			const video = this.$refs.camera;
			const canvas = this.$refs.canvas;
			const canvasPreview = this.$refs.canvasPreview;

			const context = canvas.getContext('2d');
			const contextPreview = canvasPreview.getContext('2d');

			let width = this.HD_IMAGE_SIZE.WIDTH;
			let height = this.HD_IMAGE_SIZE.HEIGHT;

			context.drawImage(video, 0, 0, width, height);
			contextPreview.drawImage(video, 0, 0, this.ipadWidth, this.ipadHeight);

			const dataURI = canvas.toDataURL('image/jpg');
			const dataURIPreview = canvasPreview.toDataURL('image/jpg');
			let file = await this.convertImageToBinary(dataURI);

			const container = {
				imageId: '',
				imageKey: '',
				imageName: file.name,
				imageURI: dataURIPreview,
				imageType: this.type.toLowerCase(),
				isLoaded: true,
			};

			this.PUSH_IMAGE({
				image: container,
			});

			this.uploadTrainerImages({
				username: this.username,
				type: this.type,
				file: file,
				fileName: file.name,
				uploadIdx: this.imagesReactiveLength,
				vueInstance: this,
				message: this.failNoti,
			});
		},
	},
	watch: {
		successUploadNumber(value) {
			if (value === LIMIT_INTERVAL_SHOT) {
				if (!this.createdModelInformation.newModelName) {
					this.SET_STEP1();
				} else {
					this.SET_STEP3();
				}
			}
		},
		mode(value) {
			this.openCamera(value, this.cameraId);
		},

		// check khi nào tắt slider thì tắt luôn nút stop
		auto: function (val) {
			if (val === false) {
				this.onInterval = false;
			}
		},
	},
};
